import JSONUtils from 'js/lib/JSONUtils';
import { useState } from 'react';
import createFlowService from 'new/components/flows/service/createFlowService';

export default function useFlows(updateFormData) {
  const [sinkMapping, setSinkMapping] = useState({ obj: {}, str: '' });
  const flowService = createFlowService();

  const onSinkMappingUpdated =
    ({ connectionCategory, sinkConfig, isEditMode }) =>
    (newSinkMapping, auto) => {
      let sinkMappingObj =
        typeof newSinkMapping === 'string' ? JSONUtils.parseJson(newSinkMapping) : newSinkMapping;
      let sinkMap = {
        str: newSinkMapping,
        obj: sinkMappingObj ? sinkMappingObj : sinkMapping.obj,
      };
      setSinkMapping(sinkMap);

      //TODO: Evaluate if this auto property is necessary in the new FormatCard component
      if (auto) {
        let sinkConfigAuto = {
          ...sinkConfig,
          mapping: { mode: 'auto' },
        };

        if (sinkMappingObj?.excludes) {
          sinkConfigAuto.mapping.excludes = sinkMappingObj.excludes;
        }

        updateFormData({
          sinkConfig: sinkConfigAuto,
        });
      } else if (sinkMappingObj) {
        let sinkConfigWithMapping = flowService.getSinkConfigWithMapping({
          sinkConfig,
          sinkMapping: sinkMap,
          isEditMode,
          connectionCategory,
        });
        updateFormData({
          sinkConfig: sinkConfigWithMapping,
        });
      }
    };

  return {
    sinkMapping,
    onSinkMappingUpdated,
  };
}
